export default {
  title: 'Account billing',
  subtitle: 'Manage your wallet, view transaction history and invoices',

  wallet: {
    currentBalance: 'Current balance',
    fundsInstant: 'Credited as soon as the payment clears',
    receipts: 'PDF receipt for every top-up',
    topUpWallet: 'Top up wallet',
  },

  invoices: {
    title: 'Invoices',
    body: 'An invoice is issued for every wallet top-up. Key orders are paid from the wallet.',
    topup: 'Wallet top-up',
    download: 'Invoice PDF',
    empty: 'No invoices yet — your first top-up creates one.',
  },

  purchaseHistory: {
    title: 'Purchase history',
    noPurchases: 'No completed purchases yet.',
    ranges: {
      all: 'All',
      thirtyDays: 'Last 30 days',
      threeMonths: 'Last 3 months',
      year: 'This year',
    },
  },

  ledger: {
    title: 'Wallet ledger',
    noActivity: 'No wallet activity yet.',
    onHold: 'On hold',
    labels: {
      topup: 'Top-up',
      held: 'Held',
      paid: 'Paid',
      purchase: 'Purchase',
      refund: 'Refund',
      adjustment: 'Adjustment',
      creditAdjustment: 'Credit adjustment',
      fee: 'Fee',
    },
  },

  topup: {
    title: 'Top up your wallet',
    amountLabel: 'Amount',
    paymentMethodLabel: 'Payment method',
    methods: {
      TRUSTLY: 'Yapili',
      CARD: 'Credit / Debit card',
    },
    redirectNote: "You'll be redirected to our secure payment provider.",
    continue: 'Continue to payment',
    redirecting: 'Redirecting…',
    devSkip: 'Dev: skip provider',
    devBusy: 'Dev top-up…',
    errorMinimum: 'Minimum top-up is €1.00.',
    errorBillingInfo: 'Please complete your billing info in Settings before topping up.',
    errorGeneric: 'Could not start top-up',
    errorDevGeneric: 'Topup failed',
  },
};
